import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SitesService {
  constructor(private http: HttpClient) {}

  async getSiteList(params: any) {
    return lastValueFrom(
      this.http
        .get(`/api/site/list_sites/`, { params: params })
        .pipe(map((response) => response)),
    );
  }
  async getPrimeContractorList(params: any) {
    return lastValueFrom(
      this.http
        .get(`/api/company/list_companies/`, { params: params })
        .pipe(map((response) => response)),
    );
  }
  async getJobList(body: any, params: any) {
    return lastValueFrom(
      this.http
        .post(`/api/job/list_all_jobs/`, body, { params: params })
        .pipe(map((response) => response)),
    );
  }
}
